import { render, staticRenderFns } from "./ClientModalComponent.vue?vue&type=template&id=23b716d0&scoped=true&"
import script from "./ClientModalComponent.vue?vue&type=script&lang=js&"
export * from "./ClientModalComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23b716d0",
  null
  
)

export default component.exports